module.exports = __webpack_public_path__ + "img/ch34.58bdad3a.png";